import React from 'react';
import { Link } from 'react-router-dom';
import Attorneys from '../../api/attorneys';

const Attorney = props => {
	const ClickHandler = () => {
		window.scrollTo(10, 0);
	};

	return (
		<section className='attorney-sec relative py-[100px]'>
			<div className='wraper'>
				<div className='col-span-12 text-center'>
					<div className='mb-[60px]'>
						<span className='text-[16px] text-[#ada282]'>A votre service</span>
						<h2 className=" text-[36px] md:text-[26px] font-medium text-[#333] pb-[20px] relative before:absolute before:content-[''] before:left-[50%] before:bottom-0 before:transform before:-translate-x-1/2 before:w-[60px] before:h-[3px] before:bg-[#c0b596]">
							Notre équipe
						</h2>
					</div>
				</div>
				<div className='grid grid-cols-12 gap-3 team-slider relative'>
					{Attorneys.map((attorney, aitem) => (
						<div
							className='col-span-6 overflow-hidden relative shadow-[1px_1px_5px_rgba(0,0,5,8%)] group'
							key={aitem}
						>
							<div className='expert-img'>
								<Link onClick={ClickHandler} to={`/equipe/${attorney.slug}`}>
									<img className='w-full' src={attorney.AtImg} alt='' />
								</Link>
							</div>
							<div className='relative text-center mt-[-40px] bg-[#f5f5f5] transform translate-y-[40px] transition ease-in-out duration-300 group-hover:translate-y-0 group-hover:bg-[#fff]'>
								<h3 className='text-[24px] col:text-[20px] font-medium pt-[30px] pb-[8px]  font-heading-font'>
									<Link
										onClick={ClickHandler}
										to={`/equipe/${attorney.slug}`}
										className='text-[#282e3f] hover:text-[#ada282] transition-all'
									>
										{attorney.name}{' '}
									</Link>
								</h3>
								<span className='text-[#ada282] text-[16px] font-normal'>{attorney.title}</span>
								<ul className='flex justify-center my-[20px] transition ease-in-out'>
									<li className='px-[10px] '>
										<p>&nbsp;</p>
									</li>
								</ul>
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default Attorney;
